import { Component, Vue } from 'vue-property-decorator';
import { PAGE_NAMES } from '@/constants';
import { Getter } from '@/decorators';
import { addNewAdmin, fetchAllAdmin, fetchUsers, removeAdmin } from '@/services';
import { TableHeaderColumns, UserDTO } from '@/models';
import Avatar from '@/components/common/avatar/Avatar.vue';
import ConfirmationDialog from '@/components/common/confirmation-dialog/ConfirmationDialog.vue';
import InlineLoader from '@/components/common/loader/inline-loader/InlineLoader.vue';
import SearchInput from '@/components/common/search-input/SearchInput.vue';
import Tooltip from '@/components/common/tooltip/Tooltip.vue';
import AddAdminForm from './add-admin-form/AddAdminForm.vue';
import Pagination from '@/components/common/pagination/Pagination.vue';

@Component({
  components: {
    SearchInput,
    InlineLoader,
    AddAdminForm,
    Avatar,
    Tooltip,
    ConfirmationDialog,
    Pagination
  }
})
export default class AdminManagement extends Vue {
  @Getter('app/currentUser') currentUser: UserDTO;
  private isAdminListFetching = true;
  private isOpenDeleteDialog = false;
  private headers: TableHeaderColumns = [
    {
      text: 'Employee ID',
      align: 'start',
      value: 'code'
    },
    { text: 'Employee Name', value: 'fullName' },
    { text: 'Email', value: 'email' },
    { text: '', value: 'delete', sortable: false }
  ];
  private admins: UserDTO[] = [];
  private users: UserDTO[] = [];
  private deleteAdminId = 0;
  private deleteAdminName = '';
  private search = '';
  private itemsPerPage = 10;
  private page = 1;
  private pageCount = 0;

  openDeleteDialog(adminId: number, adminName: string): void {
    this.deleteAdminId = adminId;
    this.deleteAdminName = adminName;
    this.isOpenDeleteDialog = true;
  }

  closeDeleteDialog(): void {
    this.isOpenDeleteDialog = false;
  }

  async addAdmin(newAdminId: number): Promise<void> {
    await addNewAdmin(newAdminId).then(payload => {
      this.admins = payload.data;
    });
  }

  async deleteAdmin(): Promise<void> {
    await removeAdmin(this.deleteAdminId).then(payload => {
      this.admins = payload.data;
    });
    this.closeDeleteDialog();
    if (this.currentUser.id === this.deleteAdminId) {
      this.$router.push({ name: PAGE_NAMES.HOME });
    }
  }

  async mounted(): Promise<void> {
    await fetchUsers().then(payload => {
      this.users = payload.data;
    });

    await fetchAllAdmin()
      .then(payload => {
        this.admins = payload.data;
      })
      .finally(() => {
        this.isAdminListFetching = false;
      });
  }

  hasOnlyOneAdmin(): boolean {
    return this.admins.length === 1;
  }

  isCurrentUser(user: UserDTO): boolean {
    return this.currentUser.id === user.id;
  }

  onSearch(searchText: string): void {
    this.search = searchText;
  }

  onPageChange(page: number): void {
    this.page = page;
  }

  onItemsPerPageChange(itemsPerPage: number): void {
    this.itemsPerPage = itemsPerPage;
  }
}
